import React from "react";

export default function Timeline() {
  return (
    <div className="" id="roadmap">
      <div className="text-white mb-32 border w-72 flex justify-end p-5 rounded-r-full font-extrabold text-2xl Teambg glassmorphicFAQ">
        ROADMAP
      </div>
      <ol className=" my-10 w-full px-16 flex 2xl:flex-row xl:flex-row lg:flex-col sm:flex-col md:flex-col justify-center items-center">
        <div className="flex 2xl:flex-row xl:flex-row lg:flex-row sm:flex-col md:flex-col">
          <li className="relative 2xl:mb-6 xl:mb-6 sm:mb-0 flex xl:flex-col 2xl:flex-col lg:flex-col">
            <div className="flex items-center 2xl:flex-row xl:flex-row lg:flex-row sm:flex-col md:flex-col">
              <div className="z-10 flex  items-center justify-center w-6 h-6 bg-blue-100 rounded-full ring-0 ring-white dark:bg-blue-900 sm:ring-8 dark:ring-gray-900 shrink-0">
                <svg
                  className="w-2.5 h-2.5 text-blue-800 dark:text-blue-300"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </div>
              <div className=" w-full bg-gray-200 h-0.5 dark:bg-gray-700 hidden xl:flex 2xl:flex lg:flex"></div>
              <div className=" h-20 bg-gray-200 w-0.5 dark:bg-gray-700 xl:hidden 2xl:hidden lg:hidden"></div>
            </div>
            <div className="lg:mt-3 md:ml-3 sm:ml-3  mb-3 2xl:mt-3 xl:mt-3 border p-3 rounded-md sm:pe-8 xl:mr-7 lg:mx-3 2xl:mr-7 glassmorphicFAQ Faqbg glassmorphic-cards shadow-greenLight">
              <h3 className="text-2xl  font-medium  bg-gradient-to-r from-gray-600 via-gray-50 to-gray-800 bg-clip-text text-transparent dark:text-white">
                Phase 1
              </h3>
              <time className="  mr-5 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                Aggregate Layer1's
              </time>
            </div>
          </li>
          <li className="relative 2xl:mb-6 xl:mb-6 sm:mb-0 flex xl:flex-col 2xl:flex-col lg:flex-col">
            <div className="flex items-center 2xl:flex-row xl:flex-row lg:flex-row sm:flex-col md:flex-col">
              <div className="z-10 flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full ring-0 ring-white dark:bg-blue-900 sm:ring-8 dark:ring-gray-900 shrink-0">
                <svg
                  className="w-2.5 h-2.5 text-blue-800 dark:text-blue-300"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </div>
              <div className=" w-full bg-gray-200 h-0.5 dark:bg-gray-700 hidden xl:flex 2xl:flex lg:flex"></div>
              <div className=" h-20 bg-gray-200 w-0.5 dark:bg-gray-700 xl:hidden 2xl:hidden lg:hidden"></div>
            </div>
            <div className="lg:mt-3 md:ml-3 sm:ml-3 mb-3  2xl:mt-3 xl:mt-3 border p-3 rounded-md sm:pe-8 xl:mr-7 lg:mx-3  2xl:mr-7 glassmorphicFAQ Faqbg glassmorphic-cards shadow-greenLight">
              <h3 className="text-2xl  font-medium  bg-gradient-to-r from-gray-600 via-gray-50 to-gray-800 bg-clip-text text-transparent dark:text-white">
                Phase 2
              </h3>
              <time className="block mb-2  mr-5 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                L2's , rollups , btc derivatives
              </time>
            </div>
          </li>
          <li className="relative 2xl:mb-6 xl:mb-6 sm:mb-0 flex xl:flex-col 2xl:flex-col lg:flex-col">
            <div className="flex items-center 2xl:flex-row xl:flex-row lg:flex-row sm:flex-col md:flex-col">
              <div className="z-10 flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full ring-0 ring-white dark:bg-blue-900 sm:ring-8 dark:ring-gray-900 shrink-0">
                <svg
                  className="w-2.5 h-2.5 text-blue-800 dark:text-blue-300"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </div>
              <div className=" w-full bg-gray-200 h-0.5 dark:bg-gray-700 hidden xl:flex 2xl:flex lg:flex"></div>
              <div className=" h-20 bg-gray-200 w-0.5 dark:bg-gray-700 xl:hidden 2xl:hidden lg:hidden"></div>
            </div>
            <div className="lg:mt-3 md:ml-3 sm:ml-3 mb-3  2xl:mt-3 xl:mt-3 border p-3 rounded-md sm:pe-8 xl:mr-7 lg:mx-3 2xl:mr-7 glassmorphicFAQ Faqbg glassmorphic-cards shadow-greenLight">
              <h3 className="text-2xl  font-medium  bg-gradient-to-r from-gray-600 via-gray-50 to-gray-800 bg-clip-text text-transparent dark:text-white">
                Phase 3
              </h3>
              <time className="block mb-2 mr-5 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                Darkpool Integration
              </time>
            </div>
          </li>
        </div>
        <div className="flex 2xl:flex-row xl:flex-row lg:flex-row sm:flex-col md:flex-col">
          <li className="relative 2xl:mb-6 xl:mb-6 sm:mb-0 flex xl:flex-col 2xl:flex-col lg:flex-col">
            <div className="flex items-center 2xl:flex-row xl:flex-row lg:flex-row sm:flex-col md:flex-col">
              <div className="z-10 flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full ring-0 ring-white dark:bg-blue-900 sm:ring-8 dark:ring-gray-900 shrink-0">
                <svg
                  className="w-2.5 h-2.5 text-blue-800 dark:text-blue-300"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </div>
              <div className=" w-full bg-gray-200 h-0.5 dark:bg-gray-700 hidden xl:flex 2xl:flex lg:flex"></div>
              <div className=" h-20 bg-gray-200 w-0.5 dark:bg-gray-700 xl:hidden 2xl:hidden lg:hidden"></div>
            </div>
            <div className="lg:mt-3 md:ml-3 sm:ml-3 mb-3  2xl:mt-3 xl:mt-3 border p-3 rounded-md sm:pe-8 xl:mr-7 lg:mx-3 2xl:mr-7 glassmorphicFAQ Faqbg glassmorphic-cards shadow-greenLight">
              <h3 className="text-2xl  font-medium  bg-gradient-to-r from-gray-600 via-gray-50 to-gray-800 bg-clip-text text-transparent dark:text-white">
                Phase 4
              </h3>
              <time className="block mb-2 mr-5 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                Aggregation As a Service
              </time>
            </div>
          </li>
          <li className="relative 2xl:mb-6 xl:mb-6 sm:mb-0 flex xl:flex-col 2xl:flex-col lg:flex-col">
            <div className="flex items-center 2xl:flex-row xl:flex-row lg:flex-row sm:flex-col md:flex-col">
              <div className="z-10 flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full ring-0 ring-white dark:bg-blue-900 sm:ring-8 dark:ring-gray-900 shrink-0">
                <svg
                  className="w-2.5 h-2.5 text-blue-800 dark:text-blue-300"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </div>
              <div className=" w-full bg-gray-200 h-0.5 dark:bg-gray-700 hidden xl:flex 2xl:flex lg:flex"></div>
              <div className=" h-20 bg-gray-200 w-0.5 dark:bg-gray-700 xl:hidden 2xl:hidden lg:hidden"></div>
            </div>
            <div className="lg:mt-3 md:ml-3 sm:ml-3 mb-3  2xl:mt-3 xl:mt-3 border p-3 rounded-md sm:pe-8 xl:mr-7 lg:mx-3 2xl:mr-7 glassmorphicFAQ Faqbg glassmorphic-cards shadow-greenLight">
              <h3 className="text-2xl gotham_font font-medium  bg-gradient-to-r from-gray-600 via-gray-50 to-gray-800 bg-clip-text text-transparent dark:text-white">
                Phase 5
              </h3>
              <time className="block mb-2 mr-5 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                Asset and Context Sharing
              </time>
            </div>
          </li>
          <li className="relative 2xl:mb-6 xl:mb-6 sm:mb-0 flex xl:flex-col 2xl:flex-col lg:flex-col">
            <div className="flex items-center 2xl:flex-row xl:flex-row lg:flex-row sm:flex-col md:flex-col">
              <div className="z-10 flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full ring-0 ring-white dark:bg-blue-900 sm:ring-8 dark:ring-gray-900 shrink-0">
                <svg
                  className="w-2.5 h-2.5 text-blue-800 dark:text-blue-300"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </div>
              <div className=" w-full bg-gray-200 h-0.5 dark:bg-gray-700 hidden xl:flex 2xl:flex lg:flex"></div>
              <div className=" h-20 bg-gray-200 w-0.5 dark:bg-gray-700 xl:hidden 2xl:hidden lg:hidden"></div>
            </div>
            <div className="lg:mt-3 md:ml-3 sm:ml-3 mb-3  2xl:mt-3 xl:mt-3 border p-3 rounded-md sm:pe-8  glassmorphicFAQ Faqbg glassmorphic-cards shadow-greenLight">
              <h3 className="text-2xl gotham_font font-medium  bg-gradient-to-r from-gray-600 via-gray-50 to-gray-800 bg-clip-text text-transparent dark:text-white">
                Phase 6
              </h3>
              <time className="block mb-2   text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                Wallet Release..
              </time>
            </div>
          </li>
        </div>
      </ol>
    </div>
  );
}
